function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgArtigosInfantis = function SvgArtigosInfantis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 9.742v1.507a4.997 4.997 0 01-2.36 4.246 2.751 2.751 0 11-3.261.754h-5.514a2.75 2.75 0 11-3.269-.75 4.997 4.997 0 01-2.365-4.25V9.373c-.02-.399-.067-.728-.162-1.084-.307-1.154-1-1.79-2.325-1.79v-1c1.819 0 2.875.97 3.291 2.532.11.414.166.786.191 1.218h6.658l1.757-5.263a1.998 1.998 0 012.341-1.317c2.938.686 4.842 3.08 5.006 6.58h.012v.493zm-1.013-.493c-.157-3.036-1.754-5.028-4.232-5.606a.998.998 0 00-1.165.66l-1.652 4.946h7.05zm.013 2v-1H5.731v1a4 4 0 004 4H16.5a4 4 0 004-4zm-10.506 6.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm9.756 0a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
    fill: props.color
  }));
};

SvgArtigosInfantis.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgArtigosInfantis.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgArtigosInfantis;